import React from 'react';

/**
 * MemberSelector - Displays a member checkbox/option with image and name
 * @param {string} name - Member's name
 * @param {string} photo - Optional photo URL
 * @param {boolean} selected - Whether the member is selected
 * @param {function} onChange - Callback when selection changes
 * @param {string} className - Additional CSS classes
 */
const MemberSelector = ({ name, photo, selected, onChange, className = '' }) => {
    const getInitials = (name) => {
        if (!name) return '?';
        const parts = name.trim().split(' ');
        if (parts.length === 1) {
            return parts[0].substring(0, 2).toUpperCase();
        }
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    };

    const getColorFromName = (name) => {
        if (!name) return 'bg-gray-500';
        const colors = [
            'bg-red-500',
            'bg-orange-500',
            'bg-yellow-500',
            'bg-green-500',
            'bg-teal-500',
            'bg-blue-500',
            'bg-indigo-500',
            'bg-purple-500',
            'bg-pink-500'
        ];
        const index = name.charCodeAt(0) % colors.length;
        return colors[index];
    };

    return (
        <label className={`flex items-center gap-3 cursor-pointer ${className}`}>
            <input
                type="checkbox"
                checked={selected}
                onChange={onChange}
                className="w-4 h-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
            />
            {photo ? (
                <img
                    src={photo}
                    alt={name}
                    className="w-8 h-8 rounded-full object-cover"
                />
            ) : (
                <div className={`w-8 h-8 rounded-full flex items-center justify-center text-white font-semibold text-sm ${getColorFromName(name)}`}>
                    {getInitials(name)}
                </div>
            )}
            <span className="text-gray-900 font-medium">{name}</span>
        </label>
    );
};

export default MemberSelector;

